import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { HeartIcon, BellIcon, ArrowLeftIcon } from 'lucide-react';
import ReactPlayer from 'react-player';
import { BottomNav } from '../components/BottomNav';
export function ToyDetail() {
  const {
    toyId
  } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLiked, setIsLiked] = useState(false);
  const [showPointsAnimation, setShowPointsAnimation] = useState(false);
  const [completedCount, setCompletedCount] = useState(0);
  const isHomePage = location.pathname === '/';
  const handleBackClick = () => {
    navigate(-1);
  };
  const currentUser = {
    name: '妈妈，张春燕',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  };
  const toys = [{
    id: '1',
    name: '柔软摇铃',
    image: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '0-6个月',
    color: 'from-pink-400 to-rose-400',
    videoUrl: 'https://youtu.be/P4VVsAvZKtw',
    description: '轻轻摇动摇铃，让宝宝感受声音和色彩的变化'
  }, {
    id: '2',
    name: '毛绒玩具',
    image: 'https://images.unsplash.com/photo-1530325553241-4f6e7690cf36?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '0-3岁',
    color: 'from-purple-400 to-pink-400',
    videoUrl: 'https://youtu.be/P4VVsAvZKtw',
    description: '柔软的毛绒玩具给宝宝温暖的陪伴和安全感'
  }, {
    id: '3',
    name: '彩色积木',
    image: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '1-3岁',
    color: 'from-red-400 to-orange-400',
    videoUrl: 'https://youtu.be/P4VVsAvZKtw',
    description: '堆叠积木，培养宝宝的空间想象力和手眼协调能力'
  }, {
    id: '4',
    name: '音乐玩具',
    image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '6个月-2岁',
    color: 'from-blue-400 to-cyan-400',
    videoUrl: 'https://youtu.be/P4VVsAvZKtw',
    description: '按下按钮，让宝宝探索不同的音乐和节奏'
  }, {
    id: '5',
    name: '布质绘本',
    image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '6个月-3岁',
    color: 'from-green-400 to-emerald-400',
    videoUrl: 'https://youtu.be/P4VVsAvZKtw',
    description: '翻开绘本，和宝宝一起探索色彩斑斓的世界'
  }, {
    id: '6',
    name: '形状配对',
    image: 'https://images.unsplash.com/photo-1606762216207-056ce4b43baa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    ageRange: '1-3岁',
    color: 'from-indigo-400 to-purple-400',
    videoUrl: 'https://youtu.be/P4VVsAvZKtw',
    description: '帮助宝宝将形状放入对应的孔中，锻炼认知能力'
  }];
  const toy = toys.find(t => t.id === toyId);
  useEffect(() => {
    // 读取该玩具的完成次数
    if (toyId) {
      const count = parseInt(localStorage.getItem(`toy-${toyId}-completed`) || '0');
      setCompletedCount(count);
    }
  }, [toyId]);
  const handleLike = () => {
    if (!isLiked) {
      setIsLiked(true);
      setShowPointsAnimation(true);
      // 增加游戏完成数
      const currentGames = parseInt(localStorage.getItem('completedGames') || '0');
      localStorage.setItem('completedGames', (currentGames + 1).toString());
      // 增加该玩具的完成次数
      if (toyId) {
        const newCount = completedCount + 1;
        setCompletedCount(newCount);
        localStorage.setItem(`toy-${toyId}-completed`, newCount.toString());
      }
      // 触发自定义事件通知其他组件
      window.dispatchEvent(new Event('localStorageUpdate'));
      setTimeout(() => {
        setShowPointsAnimation(false);
      }, 2000);
    }
  };
  if (!toy) {
    return <div className="min-h-screen bg-gradient-to-b from-purple-50 to-blue-50 flex items-center justify-center" data-id="element-485">
        <p className="text-gray-600" data-id="element-486">玩具未找到</p>
      </div>;
  }
  return <div className="min-h-screen bg-gradient-to-b from-purple-50 via-pink-50 to-blue-50 pb-16" data-id="element-487">
      <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-488">
        <div className="px-4 py-3 flex items-center justify-center relative" data-id="element-489">
          <button onClick={handleBackClick} className={'absolute left-4 transition-colors'} data-id="element-490">
            <ArrowLeftIcon size={20} className="mb-1" data-id="element-491" />
            <span className="text-xs font-medium" data-id="element-492">返回</span>
          </button>
          <h1 className="text-2xl font-bold text-amber-700" data-id="element-493">Everseed</h1>
          <div className="flex items-center space-x-3 absolute right-4" data-id="element-494">
            <Link to="/notifications" className="relative" data-id="element-495">
              <BellIcon size={24} className="text-gray-600" data-id="element-496" />
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full font-bold" data-id="element-497">
                3
              </span>
            </Link>
            <img src={currentUser.avatar} alt={currentUser.name} className="w-9 h-9 rounded-full object-cover border-2 border-indigo-200" data-id="element-498" />
          </div>
        </div>
      </header>
      <main className="px-4 py-6" data-id="element-499">
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg mb-6" data-id="element-500">
          <div className="relative aspect-video" data-id="element-501">
            <ReactPlayer url={toy.videoUrl} width="100%" height="100%" controls light playing={false} data-id="element-502" />
          </div>
          <div className={`bg-gradient-to-r ${toy.color} p-4`} data-id="element-503">
            <div className="flex items-center justify-between text-white mb-2" data-id="element-504">
              <span className="text-xs bg-white bg-opacity-30 px-3 py-1 rounded-full" data-id="element-505">
                {toy.ageRange}
              </span>
            </div>
            <p className="text-white text-sm" data-id="element-506">{toy.description}</p>
          </div>
        </div>
        <div className="bg-gradient-to-r from-pink-100 to-purple-100 rounded-2xl p-6 text-center shadow-md relative" data-id="element-507">
          <button onClick={handleLike} className={`mx-auto mb-3 transition-all duration-300 ${isLiked ? 'scale-110' : 'scale-100 active:scale-95'}`} disabled={isLiked} data-id="element-508">
            <HeartIcon size={32} className={`${isLiked ? 'text-rose-500 fill-rose-500' : 'text-rose-500 hover:fill-rose-200'} transition-all duration-300`} data-id="element-509" />
          </button>
          <p className="text-lg font-semibold text-gray-800" data-id="element-510">
            谢谢妈妈今天的陪伴
          </p>
          {isLiked && <p className="text-sm text-rose-600 mt-2 font-medium" data-id="element-511">已点亮 ❤️</p>}
          {showPointsAnimation && <div className="absolute top-4 right-4 bg-gradient-to-r from-amber-400 to-orange-500 text-white px-4 py-2 rounded-full font-bold text-sm shadow-lg animate-bounce" data-id="element-512">
              +1 积分
            </div>}
          <div className="absolute bottom-3 right-3" data-id="element-513">
            <p className="text-sm font-bold text-indigo-600" data-id="element-514">
              {completedCount}
            </p>
          </div>
        </div>
        <div className="mt-6 bg-white rounded-2xl p-4 shadow-md" data-id="element-515">
          <h3 className="text-lg font-bold text-gray-800 mb-3" data-id="element-516">玩耍小贴士</h3>
          <ul className="space-y-2 text-sm text-gray-600" data-id="element-517">
            <li className="flex items-start" data-id="element-518">
              <span className="text-indigo-600 mr-2" data-id="element-519">•</span>
              <span data-id="element-520">每天陪伴宝宝玩耍15-30分钟</span>
            </li>
            <li className="flex items-start" data-id="element-521">
              <span className="text-indigo-600 mr-2" data-id="element-522">•</span>
              <span data-id="element-523">观察宝宝的兴趣点，跟随他的节奏</span>
            </li>
            <li className="flex items-start" data-id="element-524">
              <span className="text-indigo-600 mr-2" data-id="element-525">•</span>
              <span data-id="element-526">用温柔的语言描述玩具和动作</span>
            </li>
            <li className="flex items-start" data-id="element-527">
              <span className="text-indigo-600 mr-2" data-id="element-528">•</span>
              <span data-id="element-529">给予宝宝充分的探索时间</span>
            </li>
          </ul>
        </div>
      </main>
      <BottomNav data-id="element-530" />
    </div>;
}